import {ComponentPropsWithoutRef, useMemo} from 'react';

export function useIsChecked(props: ComponentPropsWithoutRef<'input'>) {
  return useMemo(() => {
    return props.checked || props.defaultChecked;
  }, [props.checked, props.defaultChecked]);
}
